export enum StageInfluenceColumnType {
    leadStages = 'leadStages',
    opptyStages  = 'opptyStages',
}
